document.addEventListener('DOMContentLoaded', () => {
    const signUpButtons  = document.getElementsByTagName('ngp-auth-signup');
    const loginButtons  = document.getElementsByTagName('ngp-auth-login');

    [...signUpButtons, ...loginButtons].forEach((element) => element.setAttribute('post-auth-redirect', 'false'));
});
